import { render, staticRenderFns } from "./purchaseActivity.vue?vue&type=template&id=f8398280&scoped=true&"
import script from "./purchaseActivity.vue?vue&type=script&lang=js&"
export * from "./purchaseActivity.vue?vue&type=script&lang=js&"
import style0 from "./purchaseActivity.vue?vue&type=style&index=0&id=f8398280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8398280",
  null
  
)

export default component.exports